import React from 'react';
import { useStyles } from '../../styles';
import { IconButton } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';

const toDisplayText = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map(item => toDisplayText(item)).filter(Boolean).join(', ');
  }
  if (typeof value === 'object') {
    const keys = Object.keys(value as Record<string, unknown>);
    if (keys.length > 0) {
      return keys.join(', ');
    }
  }
  return String(value);
};

const List = ({ projectName, toolName, subHeader, url }: any) => {
  const classes = useStyles();

  const projectNameText = toDisplayText(projectName);
  const toolNameText = toDisplayText(toolName);
  const subHeaderText = toDisplayText(subHeader);

  return (
    <div className={`${classes.marginTop2} ${classes.marginBottomSmall}`}>
      <div className={`${classes.marginTop2} ${classes.projectDetail}`}>
        <div className={classes.flexSpacebetween}>
          <div>
            <span className={classes.fontBold}>{projectNameText}</span>
            {(toolNameText || subHeaderText) && (
              <>
                <span className={classes.fontBold}> | </span>
                <span>
                  {toolNameText} {subHeaderText}
                </span>
              </>
            )}
          </div>
          {url && (
            <IconButton
              href={url}
              target="_blank"
              classes={{ root: classes.padding0 }}
            >
              <LaunchIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default List;
